<template>
    <div class="pane user-pane">
        <div class="pane-title">
            <span>提交用户</span>
            <span class="pane-count">{{ users.length }} 人</span>
        </div>
        <div class="user-list">
            <div class="user-item" v-for="user in users" :key="userKey(user)"
                :class="{ 'is-active': selectedKey === userKey(user) }"
                @click="$emit('select', userKey(user))">
                <div class="avatar sm" :style="{ background: avatarColor(user) }">{{ (user.userName || '?').charAt(0) }}</div>
                <div class="user-info">
                    <div class="user-name">{{ user.userName }}</div>
                    <div class="user-sub">{{ userSub(user) }}</div>
                </div>
                <span class="status-capsule" :class="statusClass(user)">{{ statusText(user) }}</span>
            </div>
            <div class="empty-block sm" v-if="!users.length">{{ emptyText }}</div>
        </div>
    </div>
</template>

<script>
    import {
        overviewUserKey,
        overviewUserSub,
        overviewAvatarColor,
        overviewFeaturedAvatarColor,
        isMomentFileFeatured,
    } from '../log-moment-shared.js';

    export default {
        name: 'SubmitUserPane',
        props: {
            users: {
                type: Array,
                default: () => [],
            },
            selectedKey: {
                type: String,
                default: '',
            },
            statusMode: {
                type: String,
                default: 'submit',
            },
        },
        computed: {
            emptyText() {
                return this.statusMode === 'featured' ? '暂无提交用户' : '暂无用户';
            },
        },
        methods: {
            userKey: overviewUserKey,
            userSub: overviewUserSub,
            avatarColor(user) {
                if (this.statusMode === 'featured') return overviewFeaturedAvatarColor(user);
                return overviewAvatarColor(user);
            },
            isFeatured(user) {
                if ((user.files || []).length) {
                    return (user.files || []).some(isMomentFileFeatured);
                }
                return !!user.hasFeatured;
            },
            statusText(user) {
                if (this.statusMode === 'featured') return this.isFeatured(user) ? '已精选' : '未精选';
                return user._submitted ? '已提交' : '未提交';
            },
            statusClass(user) {
                if (this.statusMode === 'featured') {
                    return this.isFeatured(user) ? 'is-submitted' : 'is-unsubmitted';
                }
                return user._submitted ? 'is-submitted' : 'is-unsubmitted';
            },
        },
    };
</script>

<style lang="less" scoped>
    @selected-blue: #3A7BD5;
    @selected-border: #8BB8F0;
    @border-color: #EBEEF5;
    @pane-h: 520px;
    @pane-title-h: 47px;

    .pane {
        background: #fff;
        border: 1px solid @border-color;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
    }

    .pane-title {
        height: @pane-title-h;
        padding: 0 16px;
        font-size: 14px;
        font-weight: 600;
        border-bottom: 1px solid @border-color;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
    }

    .pane-count {
        font-size: 12px;
        font-weight: 400;
        color: #8B95A1;
    }

    .user-pane {
        height: @pane-h;
    }

    .user-list {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        padding: 8px;
    }

    .user-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 12px;
        border-radius: 8px;
        cursor: pointer;
        border: 1px solid transparent;
        transition: background 0.15s, border-color 0.15s;

        &:hover {
            background: #F5F7FA;
        }

        &.is-active {
            background: #fff;
            border-color: @selected-border;
            border-left: 3px solid @selected-blue;
            box-shadow: 0 0 0 3px rgba(58, 123, 213, 0.1);
        }
    }

    .user-info {
        flex: 1;
        min-width: 0;
    }

    .user-name {
        font-size: 13px;
        font-weight: 600;
    }

    .user-sub {
        font-size: 12px;
        color: #8B95A1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .status-capsule {
        display: inline-block;
        padding: 2px 10px;
        border-radius: 10px;
        font-size: 12px;
        line-height: 20px;
        margin-left: auto;
        white-space: nowrap;

        &.is-submitted {
            background: #EEF8F0;
            color: #3D9A5A;
        }

        &.is-unsubmitted {
            background: #F4F6F8;
            color: #8B95A1;
        }
    }

    .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        flex-shrink: 0;

        &.sm {
            width: 32px;
            height: 32px;
            font-size: 13px;
        }
    }

    .empty-block {
        min-height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #8B95A1;
        font-size: 13px;
        text-align: center;
        padding: 24px;

        &.sm {
            min-height: 80px;
        }
    }
</style>
